var vms = vms || {};
/* Created on 9.3.2021 by Davor */
vms.load = {
    spinner$: null,
    cnt: 0,
    add: function (pUrl, pOverlay) {
        // TODO uniform loading and check count
        if (pUrl) {
            $("body").append('<div class="vmsLoadingBar"><div class="vmsLoadingProgress"></div></div>');
            setTimeout(function () {
                vms.nav.redirect(pUrl);
            }, 1);
        } else if (pOverlay) {
            $("body").append('<div class="vmsLoading"></div>');
            if (vms.load.cnt == 0) vms.load.spinner$ = apex.util.showSpinner();
        } else {
            if (vms.load.cnt == 0) vms.load.spinner$ = apex.util.showSpinner();
        }
        vms.load.cnt++;
    },
    remove: function () {
        vms.load.cnt--;
        if (vms.load.cnt <= 0) {
            $(".vmsLoading").remove();
            vms.load.spinner$.remove();
        }
    }
};
/* Created on 8.3.2021 by Davor */
vms.toggleOffline = function (){
    apex.server.process("toggleOffline", {}, {dataType: "json",
                       success: function (pData) {
                           alert(pData.msg);
                       }
                   });
};

vms.util = vms.util || {};

/* DECIMAL SEPARATOR MULTILANGUAGE SUPPORT */
vms.util.strToNumber = function (pStr) {
    var rawValue = pStr;
    //var decimal = $v("P0_DECIMAL");
    rawValue = stripNonNumeric(rawValue, true); //
    return parseFloat(rawValue);
}

vms.util.numToString = function (pNum, pFixed) {
    var rawValue;
    if (pFixed) rawValue = pNum.toFixed(2).toString();
    else rawValue = pNum.toString();
    var decimal = $v("P0_DECIMAL");
    return rawValue.replace(".", decimal);
}

/* Gets item value as a number */
vms.util.vn = function (pItem) {
    var rawValue = $v(pItem);
    if (rawValue == "") {
        return 0;
    } else {
        return strToNumber(rawValue);
    }
}

/* Sets item value as a number */
vms.util.sn = function (pItem, pValue, pSuppress) {
    apex.item(pItem).setValue(numToString(pValue), null, pSuppress);
    //$s(, numToString(pValue));
}


vms.util.stripNonNumeric = function (str) {
    str += '';
    var rgx = /^\d|\.|-$/;
    var out = '';
    for (var i = 0; i < str.length; i++) {
        if (rgx.test(str.charAt(i))) {
            if (!((str.charAt(i) == '.' && out.indexOf('.') != -1) ||
                (str.charAt(i) == '-' && out.length != 0))) {
                out += str.charAt(i);
            }
        }
    }
    return out;
}

vms.util.roundPrice = function (pNum) {
    return (Math.round(pNum * 100) / 100);
}

vms.util.roundPriceF = function (pNum) {
    var nStr = pNum.toFixed(2) + '';
    x = nStr.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

vms.util.escapeHTML = function (pValue) {
    return apex.util.escapeHTML(pValue);
};

vms.util.stripHTML = function (pValue) {
    return apex.util.stripHTML(pValue);
};

vms.util.popup = function (url, w, h) {
	var day = new Date;
	apex.navigation.popup({
		url:    url,
        name:   day.getTime(),
        width:  w,
        height: h});
};

/* use cases: stringToDate("17/9/2014","dd/MM/yyyy","/"); stringToDate("9/17/2014","mm/dd/yyyy","/") stringToDate("9-17-2014","mm-dd-yyyy","-"); */
vms.util.stringToDate = function (_date, _format, _delimiter) {
    var formatLowerCase = _format.toLowerCase();
    var formatItems = formatLowerCase.split(_delimiter);
    var dateItems = _date.split(_delimiter);
    var monthIndex = formatItems.indexOf("mm");
    var dayIndex = formatItems.indexOf("dd");
    var yearIndex = formatItems.indexOf("yyyy");
    var month = parseInt(dateItems[monthIndex]);
    month -= 1;
    var formatedDate = new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
    return formatedDate;
};

vms.util.tdCount = function (element) {
    var divider = 2;
    var originalTable = element.clone();
    var tds = $(originalTable).children('tbody').children('tr').children('td').length;
    return tds;
}

var sn = vms.util.sn;
var vn = vms.util.vn;
var strToNumber = vms.util.strToNumber;
var numToString = vms.util.numToString;
var stripNonNumeric = vms.util.stripNonNumeric;
var roundPriceF = vms.util.roundPriceF;
var roundPrice = vms.util.roundPrice;